import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Mode } from '@bingads-webui-react/app-layout-container';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { getSideBarStyles } from '../../styles/main-menu-styles';

class CollapsibleSideBar extends React.PureComponent {
  render() {
    const {
      classes,
      mode,
      children,
      i18n,
      isPanelMode,
      permissions,
    } = this.props;
    const isNavRefresh = isNavigationRefreshOn(permissions);
    let menuClasses = '';

    switch (mode) {
      case Mode.Hidden:
        menuClasses = [classes.hidden, 'ui-next-hidden-main-menu'];
        break;
      case Mode.Collapsed:
        if (isPanelMode) {
          menuClasses = ['ui-next-main-menu'];
        } else {
          menuClasses = ['ui-next-collapsed-main-menu'];
        }
        break;
      case Mode.Expanded:
      default:
        menuClasses = ['ui-next-main-menu'];
        break;
    }

    menuClasses.push('main-menu');

    const menuClassName = classNames(_.compact([
      classes.sideBarContainer,
      isNavRefresh ? null : classes.sideBarDarkBackGround,
      menuClasses,
    ]));

    return (
      <nav className={menuClassName} aria-label={i18n.getString(_TL_('Main menu'))}>
        <div className={classNames(classes.majorComponentsContainer, isNavRefresh ? '' : classes.containerBorder)}>
          {children}
        </div>
      </nav>
    );
  }
}

CollapsibleSideBar.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getSideBarStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  mode: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isPanelMode: PropTypes.bool.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

export const StyledCollapsibleSideBar = withPermissions(withDefaultStyles(CollapsibleSideBar, getSideBarStyles));
